import { render, staticRenderFns } from "./slist.vue?vue&type=template&id=5afede6c&scoped=true&"
import script from "./slist.vue?vue&type=script&lang=js&"
export * from "./slist.vue?vue&type=script&lang=js&"
import style0 from "./slist.vue?vue&type=style&index=0&id=5afede6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afede6c",
  null
  
)

export default component.exports